import { request, requestImage } from "../apis";
import { getCurrency } from "../plugins/utils";
const CURRENCY = getCurrency();

export const getUserInfo = ({ params }) =>
  request("get", `/${CURRENCY}/agent/info`, { ...params }, true, false);

export const apiUploadImage = ({ params }) =>
  requestImage("post", `/api/image/upload`, params, true, false);

export const apiGetOpenedGameCategory = () =>
  request("get", `/${CURRENCY}/game/category/open`, {}, true);

export const getSetting = ({ userCurrency }) =>
  request("get", `/${userCurrency}/setting`, {}, true, false);
